/**
 * Type definition for base64 URL string
 */
type Base64URLString = string;

/**
 * Upscales an image using the getimg.ai API
 * @param input The image file, file input event, or base64 string to process
 * @returns A Promise that resolves to a base64 string of the upscaled image or null if no valid input was provided
 */
export const handleUpscale = async (
  input: Base64URLString
): Promise<Base64URLString | null> => {
  const API_URL = "https://api.getimg.ai/v1/enhancements/upscale";


  try {
    // Extract the base64 string from the data URL if it's in that format
    let base64String = input;
    if (input.startsWith('data:')) {
      base64String = input.split(',')[1];
    }

    const payload = {
      model: "real-esrgan-4x",
      image: base64String,
      scale: 4,
      output_format: "jpeg",
      response_format: "b64",
    };

    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${import.meta.env.VITE_GETIMG_ACCESS_KEY}`,
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error:", response.status, errorData);
      throw new Error(`Upscale failed with status ${response.status}`);
    }

    // API returns JSON with a b64 field containing the base64 encoded image
    const data = await response.json();
    
    // Return as a data URL
    return `data:image/jpeg;base64,${data.image}`;
  } catch (error) {
    console.error("Upscale request failed:", error);
    throw error;
  }
};

  